import useBreakpoint from "use-breakpoint";
import { Button, Carousel, Container } from "react-bootstrap";
import { BREAKPOINTS } from "../../utils/Constants";
import { CustomImage } from "../../components/CustomImage/CustomImage";
import { useTranslation } from '../../hooks/translation/useTranslation';
import useCountry from "../../hooks/config/useConfig";
import { useLinks } from "../../hooks/config/useLinks";

export const BannerTop = () => {
  const { breakpoint } = useBreakpoint(BREAKPOINTS, "xs");
  const { country  } = useCountry();
  const { mainProjectsUrl } = useLinks()
  const translation : any = useTranslation(country.toLowerCase())

  const images = [
    "https://cdn1.infocasas.com.uy/web/68eeae8fec84d_imagenesiris2.png",
    "https://cdn1.infocasas.com.uy/web/68eeae8fec311_imageneiris1.png",
    "https://cdn1.infocasas.com.uy/web/68eeae90a269d_imagenesiris3.png",
    "https://cdn1.infocasas.com.uy/web/68eeae8f524ff_imagenesiris4.png",
  ];
  return (
    <div className="home-banner-top position-relative">
      <Container className="home-banner-top-cta position-absolute text-white">
        <div className={`home-banner-top-text ${breakpoint === "xs" ? "ms-3" : ""}`}>
          <h1 className="display-4 home-banner-title fw-bold lh-sm">
            Empieza a vender obra nueva sin barreras
          </h1>
          <p className={"fs-3 lh-sm home-banner-top-texto mb-4 " + (breakpoint === "md" || breakpoint === "sm" || breakpoint === "xs" ? "mt-1" : "mt-4")}>
          Accede a más de 140 proyectos en todo el país, garantías al instante, gestión comercial y más.          
          </p>
          <p className={"fs-3 lh-sm home-banner-top-texto mb-4 " + (breakpoint === "md" || breakpoint === "sm" || breakpoint === "xs" ? "mt-1" : "mt-4")}>
            Plataforma <strong className="fs-2"> exclusiva</strong> para broker e inmobiliarias.
          </p>
          <Button href={mainProjectsUrl} className="home-banner-btn">
            Contratalo ahora
          </Button>
        </div>
      </Container>
      <Carousel controls={false} touch interval={4000} className="h-100">
        {images.map((item, index) => (
          <Carousel.Item key={"slide_" + index} className="h-100">
            <div className="w-100 position-relative">
              <div className="gradient-overlay w-100 position-absolute"></div>
              <CustomImage
                classes="d-block w-100"
                src={item}
                alt="Empieza a vender obra nueva sin barreras"
                width={500}
                height={500}
              />
            </div>
            <div className="home-banner-top-text-container w-100 h-100 d-flex align-items-center">
              {
                index === 0 || index === 2 ?
                  (
                    <div className="home-banner-message position-absolute end-0 d-flex justify-content-center align-self-end pb-3 pe-4">
                      <img src={window.location.origin + '/images/message-bg.png'}></img>
                      <p
                        className="position-absolute top-0"
                        dangerouslySetInnerHTML={{
                          __html: index === 0 ? `Más de <strong>5000 ${translation.developer?.toLowerCase()}s ya se registraron</strong> en Iris` : 'Incrementa tus ventas <strong>hasta en un 100% más</strong>'
                        }}
                      >
                      </p>
                    </div>
                  ) : ""
              }
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
};
